export default __webpack_public_path__ + "assets/apple-touch-icon-72x72-b734ad7.png";